"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MessagingConstants_1 = __importDefault(require("../../../shared/constants/MessagingConstants"));
var ApiResponse_1 = __importDefault(require("../../../api/v2/ApiResponse"));
var ICameraHandler_1 = require("../interfaces/ICameraHandler");
var CameraApi = /** @class */ (function () {
    // #endregion Properties (4)
    // #region Constructors (1)
    function CameraApi(_api, _threeDManager) {
        this._api = _api;
        this._threeDManager = _threeDManager;
    }
    // #endregion Constructors (1)
    // #region Public Methods (8)
    CameraApi.prototype.addEventListener = function (type, callback) {
        // check if event type is supported
        if (!Object.values(ICameraHandler_1.CameraEventType).includes(type))
            return ApiResponse_1.default('Unsupported event type');
        // compose topic and subscribe to message stream
        var t = MessagingConstants_1.default.messageTopics.SCENE_CAMERA + '.' + type;
        var subtokens = this._api.subscribeToMessageStream(t, function (topic, msg) {
            // create event object, add common event properties
            var event = new CustomEvent(type);
            event['api'] = msg.api;
            if (msg.token)
                event['token'] = msg.token;
            // get relevant data parts from message, add special event properties
            var partTypes = {};
            partTypes[MessagingConstants_1.default.messageDataTypes.GENERIC] = null; // null: copy all properties
            partTypes[MessagingConstants_1.default.messageDataTypes.SCENE_CAMERA] = null; // null: copy all properties
            for (var pt in partTypes) {
                var part = msg.getUniquePartByType(pt);
                if (part) {
                    if (part.data)
                        part = part.data;
                    // add special event properties
                    var props = partTypes[pt] ? partTypes[pt] : part;
                    for (var k in props) {
                        event[k] = part[k];
                    }
                }
            }
            // invoke callback (exception handling takes place in this._api.subscribeToMessageStream)
            callback(event);
        });
        if (subtokens)
            this._threeDManager.cameraHandler.increaseEventListenerCounter();
        return ApiResponse_1.default(null, subtokens);
    };
    CameraApi.prototype.animateAsync = function (path, transition) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._threeDManager.cameraHandler.setCameraPath(path, transition)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, ApiResponse_1.default(response ? null : 'Camera path animation failed', this._threeDManager.cameraHandler.getPositionAndTarget())];
                }
            });
        });
    };
    CameraApi.prototype.get = function () {
        return ApiResponse_1.default(null, this._threeDManager.cameraHandler.getPositionAndTarget());
    };
    CameraApi.prototype.removeEventListener = function (token) {
        var result = this._api.unsubscribeFromMessageStream(token);
        if (result)
            this._threeDManager.cameraHandler.decreaseEventListenerCounter();
        return ApiResponse_1.default(null, result);
    };
    CameraApi.prototype.resetAsync = function (transition) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._threeDManager.cameraHandler.resetPositionAndTarget(transition)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, ApiResponse_1.default(response ? null : 'Resetting camera position or target failed', this._threeDManager.cameraHandler.getPositionAndTarget())];
                }
            });
        });
    };
    CameraApi.prototype.updateAsync = function (camera, transition) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._threeDManager.cameraHandler.setPositionAndTarget(camera.position, camera.target, transition)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, ApiResponse_1.default(response ? null : 'Setting new camera target and position failed', this._threeDManager.cameraHandler.getPositionAndTarget())];
                }
            });
        });
    };
    CameraApi.prototype.updateMatrices = function (viewMatrix, projectionMatrix) {
        this._threeDManager.cameraHandler.setViewAndProjectionMatrix(viewMatrix, projectionMatrix);
    };
    CameraApi.prototype.zoomAsync = function (scenePathsOrBB, transition) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._threeDManager.cameraHandler.zoomExtents(transition, scenePathsOrBB)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, ApiResponse_1.default(response ? null : 'Zooming to extents failed', this._threeDManager.cameraHandler.getPositionAndTarget())];
                }
            });
        });
    };
    return CameraApi;
}());
exports.CameraApi = CameraApi;
